import { Icon, message } from 'antd';
import React, { useState, useEffect } from 'react';
import { proceedProof } from '../../../../../utils/services/statusMonitoringAPI';
import { ProofViewer } from '../../BatchJobs/components/ProofViewer';
import { useTranslation } from 'react-i18next';
import { PROOFS_TAB as trans } from '../TranslationValues';

const NAMESPACE = ['PROOFS_TAB'];

const ProofsTab = ({ batch }) => {
  const { t } = useTranslation(NAMESPACE);
  const [proffDataList, setProffDataList] = useState();

  const [totalProofCount, setTotalProofCount] = useState({ print: 0, email: 0 });
  const [proofsApproved, setProofsApproved] = useState(false);

  useEffect(() => {
    const getProofsInfo = async () => {
      try {
        const payload = {
          search: [
            {
              fieldName: 'stage',
              value: 'yet_to_start',
            },
            {
              fieldName: 'channel',
              value:
                (batch?.channelType?.toLowerCase() === 'multichannel' || batch?.channelType?.toLowerCase() === 'multi channel')
                  ? 'print'
                  : batch?.channelType?.toLowerCase(),
            },
          ],
          jobId: batch?.id,
        };

        const response = await proceedProof(payload);
        setProffDataList(response?.data?.proofs);
        setTotalProofCount({ print: response?.data?.printCount, email: response?.data?.emailCount });
      } catch (error) {
        message.error(t(trans.PROOFS_FETCH_FAILED.key, trans.PROOFS_FETCH_FAILED.value));
      }
    };

    getProofsInfo();
  }, []);


  return (
    <div>
      {batch?.jobDetails?.proofs && batch?.jobDetails.proofs.length > 0 ? (
        // <ProofViewer
        //     format={batch.deliveryChannel || 'PRINT'}
        //     selectedTemplate={batch.template}
        //     templates={[]}
        //     onApprove={() => { }}
        //     isApproved={true}
        //     proofs={batch.jobDetails.proofs}
        // />
        <></>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <ProofViewer
            format={batch?.channelType}
            proffDataList={proffDataList}
            setProffDataList={setProffDataList}
            totalProofCount={totalProofCount}
            setTotalProofCount={setTotalProofCount}
            proofsApproved={proofsApproved}
            setProofsApproved={setProofsApproved}
            isProofsTab={true}
            batchId={batch?.id}
          />
          {/* <Icon
            type="info-circle"
            style={{ fontSize: '48px', color: '#d1d5db', marginBottom: '1rem' }}
          />
          <p style={{ color: '#6b7280' }}>No proofs available for this job</p> */}
        </div>
      )}
    </div>
  );
};

export default ProofsTab;
